import config from '../config';

/**
 * Return a Parser that does nothing. This is used when parsing is set to null in availability/geometry
 * @returns {Parser}
 */
const getIdentityParser = function () {
  return data => data;
};

/**
 * Return a Parser that returns null. This is used when parsing is set to null in tooltip
 * @returns {Parser}
 */
const getNullParser = function () {
  return data => null;
};

/**
 * This function will return the configured parser of the requested type
 * @param {String<availability|geometry|tooltip>} type
 * @returns {Parser}
 */
export function getConfiguredParser (type) {
  var configuredParser, fallbackParser;

  // Depending on the current config option, return the appropriate parser
  switch (type) {
    case 'availability':
      configuredParser = config.availability.parser;
      fallbackParser = getIdentityParser();
      break;
    case 'geometry':
      configuredParser = config.geometry.parser;
      fallbackParser = getIdentityParser();
      break;
    case 'tooltip':
      configuredParser = config.tooltip.parser;
      fallbackParser = getNullParser();
      break;
    default:
      throw new Error('getConfiguredParser: invalid parser type.\n' +
        'Only accepted types are "availability", "geometry" and "tooltip"');
  }


  // if the configuredParser set to null, return the fallback Parser
  if (configuredParser === null) {
    return fallbackParser;
  }

  if (typeof configuredParser === 'function') {
    return configuredParser;
  }

  throw new Error('getConfiguredParser: invalid parser configuration.\n' +
    'Please specify a ' + type + ' parser or set the parsing flag to null.');
}

/**
 * Export directly the parse function
 * @param type
 * @param main
 * @param sub
 * @returns {*}
 */
export function parse (type, main, sub) {
  return getConfiguredParser(type)(main, sub);
}



// WEBPACK FOOTER //
// ./frontend/react/sim/core/utils/parsers.js